import RobotIntro from "../assets/pictures/robot_intro.gif";

export default function Tutorial() {
  return (
    <>
      <div className="tutorial-container">
        <div className="container-title">Ahoj!</div>
        <div className="container-content">
          <p>Ja som robot Tomáš.</p>
          <p>Neďaleko odtiaľto som započul neznáme zvuky.</p>
          <p>
            Hľadám k sebe pomocníka, ktorý by mi pomohol tieto zvuky rozpoznať.
          </p>
          <p>Pomôžeš mi?</p>
        </div>
      </div>
      <img
        src={RobotIntro}
        className="robot"
        id="robot-intro"
        alt="Animation error"
      ></img>
    </>
  );
}
